import { Box, Button, Container, Stack, TextField, Typography } from '@mui/material'
import Footer from 'splash_components/Splash/CommonComponents/Footer';
import { NavigationBar } from 'splash_components/Splash/CommonComponents/NavigationBar';
import { useTheme } from "@mui/material/styles";
import React, { useState } from 'react'
import { tSplash } from 'locales/splash/cruxTranslation';
import { useSnackbar } from 'notistack';

interface Props {

}

export default function SplashContact(props: Props) {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();

  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [gymName, setGymName] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    // Basic email validation
    const emailRegex = /.+@.+\..+/;
    if (!emailRegex.test(email)) {
      enqueueSnackbar(tSplash("contact.errors.invalid_email"), { variant: 'error' });
      return;
    }

    // Length validation
    if (email.length > 1000) {
      enqueueSnackbar(tSplash("contact.errors.long_email"), { variant: 'error' });
      return;
    }
    if (name.length > 1000) {
      enqueueSnackbar(tSplash("contact.errors.long_name"), { variant: 'error' });
      return;
    }
    if (gymName.length > 1000) {
      enqueueSnackbar(tSplash("contact.errors.long_gym_name"), { variant: 'error' });
      return;
    }
    if (message.length > 1000) {
      enqueueSnackbar(tSplash("contact.errors.long_message"), { variant: 'error' });
      return;
    }

    const form = e.target as HTMLFormElement;
    form.submit();
  }

  const formContent = (
    <form
      action="/submit_message"
      method="POST"
      onSubmit={handleSubmit}
    >
      <input type="hidden" name="formType" value="contact_page" />
      <input type="hidden" name="authenticity_token" value={document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content} />

      <Stack direction="column" spacing={2} alignItems="flex-start">
        <TextField
          label={tSplash("contact.your_email")}
          variant="outlined"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          fullWidth
        />
        <TextField
          label={tSplash("contact.your_name")}
          variant="outlined"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
        />
        <TextField
          label={tSplash("contact.gym_name")}
          variant="outlined"
          name="gymName"
          value={gymName}
          onChange={(e) => setGymName(e.target.value)}
          fullWidth
        />
        <TextField
          label={tSplash("contact.your_message")}
          variant="outlined"
          name="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          multiline
          rows={4}
          fullWidth
        />
        <Button variant="contained" type="submit">
          {tSplash("contact.send_message")}
        </Button>
      </Stack>
    </form>
  );

  return (
    <div style={{ backgroundColor: "#F4F4F1", userSelect: "text" }}>
      {screen.width < theme.breakpoints.values.sm ? (
        // Mobile
        <>
          <NavigationBar theme={theme} mobile />
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
              paddingTop: theme.spacing(5),
            }}
          >
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={4}
            >
              <Stack direction="row" justifyContent="center" alignItems="center">
                <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "75px" }} />
              </Stack>

              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  <b>
                    {tSplash("contact.title")}
                  </b>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ textAlign: "center", marginTop: theme.spacing(1), maxWidth: "80%", fontWeight: 400 }}
                >
                  {tSplash("contact.subtitle")}
                </Typography>
                <Stack direction="column" alignItems="center" width="100%" mt={2} mb={4}>
                  <Box pl={1} pr={1} width="100%">
                    {formContent}
                  </Box>
                </Stack>
              </Stack>
            </Stack>
          </Container>
          <Footer theme={theme} />
        </>
      ) : (
        // Desktop
        <>
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
            }}
          >
            <NavigationBar theme={theme} mobile={false} />
            <Box pt={theme.spacing(12)} pb={theme.spacing(7)}>
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
              >
                <Stack direction="row" justifyContent="center" alignItems="center">
                  <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "100px" }} />
                </Stack>

                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography variant="h2" sx={{ textAlign: "center", fontWeight: 900, maxWidth: "800px" }}>
                    {tSplash("contact.title")}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ textAlign: "center", marginTop: theme.spacing(1), maxWidth: "80%", fontWeight: 400 }}
                  >
                    {tSplash("contact.subtitle")}
                  </Typography>
                  <Stack direction="column" alignItems="center" width="100%" mt={2}>
                    <Box sx={{ '& form > div > .MuiTextField-root': { minWidth: "400px" } }}>
                      {formContent}
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Container>
          <Footer theme={theme} />
        </>
      )}
    </div>
  )
}
